import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [activeLink, setActiveLink] = useState('features');

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setActiveLink(sectionId);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-[#0A0E27]/95 backdrop-blur-xl shadow-lg'
          : 'bg-[#0A0E27]/85 backdrop-blur-xl'
      }`}
      style={{ margin: '40px', borderRadius: '16px', height: '70px' }}
    >
      <div className="h-full px-20 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <div className="w-10 h-10 flex items-center justify-center">
            <i className="ri-shield-check-fill text-3xl text-[#00D4FF]"></i>
          </div>
          <span className="text-white text-2xl font-bold tracking-tight">SUBJEKT</span>
        </div>

        {/* Navigation Links */}
        <div className="flex items-center gap-11">
          {[
            { id: 'features', label: 'Features' },
            { id: 'security', label: 'Security' },
            { id: 'about', label: 'About' },
            { id: 'contact', label: 'Contact' }
          ].map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className={`text-base font-medium transition-all duration-300 relative whitespace-nowrap ${
                activeLink === link.id ? 'text-white' : 'text-white/70 hover:text-white'
              }`}
            >
              {link.label}
              {activeLink === link.id && (
                <span className="absolute -bottom-2 left-0 right-0 h-0.5 bg-[#00D4FF]"></span>
              )}
            </button>
          ))}
        </div>

        {/* Download Button */}
        <button className="px-8 h-10 rounded-3xl border border-[#00D4FF] bg-transparent text-white font-medium transition-all duration-300 hover:bg-gradient-to-r hover:from-[#00D4FF] hover:to-[#0099CC] hover:border-transparent whitespace-nowrap cursor-pointer">
          Download App
        </button>
      </div>
    </nav>
  );
}
